<template>
  <div>
    <!-- Filter Start -->
    <custom-filter :getFilterOnStart="true" @filterChange="changeFilter"></custom-filter>
    <!-- Filter End -->

    <!-- Chart Start -->
    <div class="row mt-4">
      <div class="col">
        <div class="innerBox">
          <div class="row">
            <div class="col-md-8">
              <h5 class="elegant--sub-title">
                Checking Report
                <!-- <i class="far fa-info-circle" id="checking-report"></i> -->
                <svg id="checking-report" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.04729 4.10352C6.04729 3.74716 6.33885 3.45559 6.69521 3.45559H7.12716C7.48352 3.45559 7.77508 3.74716 7.77508 4.10352V4.53546C7.77508 4.89182 7.48352 5.18339 7.12716 5.18339H6.69521C6.33885 5.18339 6.04729 4.89182 6.04729 4.53546V4.10352ZM8.63898 10.3668H5.18339V9.50288H6.04729V6.91118H5.18339V6.04729H7.77508V9.50288H8.63898L8.63898 10.3668ZM6.91118 3.57628e-07C3.09424 3.57628e-07 0 3.09424 0 6.91118C0 10.7281 3.09424 13.8224 6.91118 13.8224C10.7281 13.8224 13.8224 10.7281 13.8224 6.91118C13.8224 3.09424 10.7281 3.57628e-07 6.91118 3.57628e-07ZM6.91118 12.5265C3.80992 12.5265 1.29585 10.0124 1.29585 6.91118C1.29585 3.80992 3.80992 1.29585 6.91118 1.29585C10.0124 1.29585 12.5265 3.80992 12.5265 6.91118C12.5265 10.0124 10.0124 12.5265 6.91118 12.5265Z" fill="#D1D1D1"/>
                </svg>
                <b-popover target="checking-report" triggers="hover" placement="top">
                  <template #title>Checking Report</template>
                  <div v-html="tooltip.checking_report"></div>
                </b-popover>
              </h5>
            </div>
            <div class="col-md-2">
              <MultiSelect v-model="filter.labelmaker" :options="options.labelMaker" placeholder="All Label Makers"
                class="elegant-multiselect" :select-label="''" @input="onLabelMakerFilterChange" />
            </div>
            <div class="col-md-2">
              <button @click="
                exportExcel(
                  data.checkingReportChart,
                  'Checking Report Label Maker Download'
                )
                " class="btn btn-elegant-download">
                Download Excel <img src="@/assets/Group 1745.svg" alt="View Map"
                       style="width: 14px; height: 14px; cursor: pointer; margin-left: 16px; position: relative; top: -2px;"/>
              </button>
            </div>
          </div>
          <checking-report-chart v-if="data.checkingReportChart" :data="data.checkingReportChart"
            :filter="filter"></checking-report-chart>
          <div v-else class="text-center mt-5 mb-5">
            <h2 class="pt-5 pb-5">Loading...</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- Chart End -->

    <div class="innerBox mt-4 bg-white shadow box-content">
      <div class="row">
        <div class="col-md-10">
          <h5 class="elegant--sub-title">
            Report by Purchase Order
            <!-- <i class="far fa-info-circle" id="report-by-purchase-order"></i> -->
            <svg id="report-by-purchase-order" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.04729 4.10352C6.04729 3.74716 6.33885 3.45559 6.69521 3.45559H7.12716C7.48352 3.45559 7.77508 3.74716 7.77508 4.10352V4.53546C7.77508 4.89182 7.48352 5.18339 7.12716 5.18339H6.69521C6.33885 5.18339 6.04729 4.89182 6.04729 4.53546V4.10352ZM8.63898 10.3668H5.18339V9.50288H6.04729V6.91118H5.18339V6.04729H7.77508V9.50288H8.63898L8.63898 10.3668ZM6.91118 3.57628e-07C3.09424 3.57628e-07 0 3.09424 0 6.91118C0 10.7281 3.09424 13.8224 6.91118 13.8224C10.7281 13.8224 13.8224 10.7281 13.8224 6.91118C13.8224 3.09424 10.7281 3.57628e-07 6.91118 3.57628e-07ZM6.91118 12.5265C3.80992 12.5265 1.29585 10.0124 1.29585 6.91118C1.29585 3.80992 3.80992 1.29585 6.91118 1.29585C10.0124 1.29585 12.5265 3.80992 12.5265 6.91118C12.5265 10.0124 10.0124 12.5265 6.91118 12.5265Z" fill="#D1D1D1"/>
            </svg>
            <b-popover target="report-by-purchase-order" triggers="hover" placement="bottom">
              <template #title>Report by Purchase Order</template>
              <div v-html="tooltip.report_by_purchase_order"></div>
            </b-popover>
          </h5>
        </div>
        <div class="col-md-2">
          <button @click="
            downloadReportbyPOExcel(
              data.reportByPo,
              'Report by Purchase Order Download'
            )
            " class="btn btn-elegant-download">
             Download Excel <img src="@/assets/Group 1745.svg" alt="View Map"
                       style="width: 14px; height: 14px; cursor: pointer; margin-left: 16px; position: relative; top: -2px;"/>
          </button>
        </div>
      </div>

      <report-by-po v-if="data.reportByPo" :data="data.reportByPo"></report-by-po>
      <div v-else class="text-center mt-5 mb-5">
        <h2 class="pt-5 pb-5">Loading...</h2>
      </div>
    </div>

    <!-- Table Start -->
    <div class="innerBox mt-4 bg-white shadow box-content">
      <div class="row">
        <div class="col-md-10">
          <h5 class="elegant--sub-title">
            History Report
            <!-- <i class="far fa-info-circle" id="history-report"></i> -->
            <svg id="history-report" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.04729 4.10352C6.04729 3.74716 6.33885 3.45559 6.69521 3.45559H7.12716C7.48352 3.45559 7.77508 3.74716 7.77508 4.10352V4.53546C7.77508 4.89182 7.48352 5.18339 7.12716 5.18339H6.69521C6.33885 5.18339 6.04729 4.89182 6.04729 4.53546V4.10352ZM8.63898 10.3668H5.18339V9.50288H6.04729V6.91118H5.18339V6.04729H7.77508V9.50288H8.63898L8.63898 10.3668ZM6.91118 3.57628e-07C3.09424 3.57628e-07 0 3.09424 0 6.91118C0 10.7281 3.09424 13.8224 6.91118 13.8224C10.7281 13.8224 13.8224 10.7281 13.8224 6.91118C13.8224 3.09424 10.7281 3.57628e-07 6.91118 3.57628e-07ZM6.91118 12.5265C3.80992 12.5265 1.29585 10.0124 1.29585 6.91118C1.29585 3.80992 3.80992 1.29585 6.91118 1.29585C10.0124 1.29585 12.5265 3.80992 12.5265 6.91118C12.5265 10.0124 10.0124 12.5265 6.91118 12.5265Z" fill="#D1D1D1"/>
            </svg>
            <b-popover target="history-report" triggers="hover" placement="bottom">
              <template #title>History Report</template>
              <div v-html="tooltip.history_report"></div>
            </b-popover>
          </h5>
        </div>
        <div class="col-md-2">
          <button @click="downloadReportHistoryExcel" class="btn btn-elegant-download">
            Download Excel <img src="@/assets/Group 1745.svg" alt="View Map"
                       style="width: 14px; height: 14px; cursor: pointer; margin-left: 16px; position: relative; top: -2px;"/>
          </button>
        </div>
      </div>
      <div class="mt-3 scan-history-table-wrapper">
        <!-- Loading State -->
        <div v-if="historyTableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>
        
        <!-- Table -->
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>Kode QR</th>
                <th>Serial No</th>
                <th>Label Maker</th>
                <th>Variant</th>
                <th>Volume</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in historyTableData" :key="index">
                <td>{{ row.qrcode || 'N/A' }}</td>
                <td>{{ row.serial_number || 'N/A' }}</td>
                <td>{{ row.label_maker || 'N/A' }}</td>
                <td>{{ row.product_name || 'N/A' }}</td>
                <td>{{ row.volume || 'N/A' }}</td>
                <td :style="getStatusStyle(row.status)">{{ row.status || 'N/A' }}</td>
                <td>{{ formatDate(row.scan_date) }}</td>
              </tr>
              <tr v-if="!historyTableLoading && historyTableData.length === 0">
                <td colspan="7" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mt-3" v-if="!historyTableLoading && (historyTableData.length > 0 || historyMaxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center">
              <label for="history-view-items-per-page" style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px;">View</label>
              <select 
                id="history-view-items-per-page"
                v-model="historyLimitPerPage" 
                @change="onHistoryLimitChange"
                class="form-control form-control-sm"
                style="width: auto; display: inline-block; padding: 4px 8px;">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px;">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0;">
                Showing {{ (historyCurrentPage - 1) * historyLimitPerPage + 1 }}-{{ historyCurrentPage * historyLimitPerPage < historyTotal ? historyCurrentPage * historyLimitPerPage : historyTotal }} of {{ historyTotal > 0 ? historyTotal : '?' }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                  <li class="page-item" :class="{ disabled: historyCurrentPage <= 1 }" @click.stop.prevent="changeHistoryPage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: historyCurrentPage >= historyMaxPage && !hasMoreHistoryData }" @click.stop.prevent="changeHistoryPage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table End -->
  </div>
</template>

<script>
import qs from "qs";
import * as XLSX from "xlsx";
import moment from "moment";
import customFilter from "@/components/filter/customFilter";
// import highlightStats from './children/HighlightStats'

import checkingReportChart from "./children/checkingReportChart.vue";

import reportByPo from "./children/LabelReportByPO";

export default {
  metaInfo: {
    title: "Report - Label Maker",
  },
  data() {
    return {
      tooltip: this.$store.state.tooltip.reports,
      filterChangeCount: 0, // Track number of filter changes
      isChangingFilter: false, // Flag to prevent watcher from triggering during changeFilter
      filter: {
        labelmaker: null,
      },
      data: {
        checkingReportChart: null,
        reportByPo: null,
        historyReport: null,
      },
      options: {
        labelMaker: this.$store.getters.getLabelMaker,
      },
      // History table data
      historyTableData: [],
      historyTableLoading: false,
      historyCurrentPage: 1,
      historyMaxPage: 1,
      historyTotal: 0,
      historyLimitPerPage: 10,
      historyFetchDataTimer: null,
    };
  },
  components: {
    customFilter,
    // highlightStats,

    checkingReportChart,
    reportByPo,
  },
  computed: {
    hasMoreHistoryData() {
      // If we got a full page of data, there's likely more
      return this.historyTableData.length === this.historyLimitPerPage;
    },
  },
  created() {
    console.log("[ReportLabelMaker] CREATED - Component instance created");
  },
  mounted() {
    console.log("[ReportLabelMaker] MOUNTED - Component instance mounted");
    // Initial data fetch will be handled by customFilter's filterChange emission
  },
  beforeDestroy() {
    console.log("[ReportLabelMaker] DESTROYED - Component instance destroyed");
    if (this.historyFetchDataTimer) {
      clearTimeout(this.historyFetchDataTimer);
    }
  },
  watch: {
    "filter.labelmaker": {
      handler(newVal, oldVal) {
        console.log("[ReportLabelMaker] Watcher triggered - newVal:", newVal, "oldVal:", oldVal);
        console.log("[ReportLabelMaker] isChangingFilter:", this.isChangingFilter, "filterChangeCount:", this.filterChangeCount);
        
        // Skip if changeFilter is currently running (to prevent duplicate API calls)
        if (this.isChangingFilter) {
          console.log("[ReportLabelMaker] Skipping - changeFilter is running");
          return;
        }
        
        // Skip if value hasn't actually changed (using JSON.stringify to handle array comparison)
        const newValStr = JSON.stringify(newVal || null);
        const oldValStr = JSON.stringify(oldVal || null);
        
        console.log("[ReportLabelMaker] Value comparison - newValStr:", newValStr, "oldValStr:", oldValStr);
        
        if (newValStr !== oldValStr) {
          console.log("[ReportLabelMaker] filter.labelmaker changed - triggering fetchData()");
          // Refresh data
          this.fetchData();
          // Reset history table to first page and fetch
          this.historyCurrentPage = 1;
          this.fetchHistoryData();
        } else {
          console.log("[ReportLabelMaker] Values are the same - skipping fetchData()");
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    onLabelMakerFilterChange(value) {
      console.log("[ReportLabelMaker] onLabelMakerFilterChange called with value:", value);
      // Set flag to prevent watcher from triggering (since v-model already updated filter.labelmaker)
      this.isChangingFilter = true;
      // Refresh data
      this.fetchData();
      // Reset history table to first page and fetch
      this.historyCurrentPage = 1;
      this.fetchHistoryData();
      // Reset flag after a brief moment to allow future changes
      this.$nextTick(() => {
        this.isChangingFilter = false;
      });
    },
    changeFilter(filter) {
      this.isChangingFilter = true; // Set flag to prevent watcher from triggering
      this.filterChangeCount++;
      console.log("[ReportLabelMaker] changeFilter #" + this.filterChangeCount);

      for (var i in filter) {
        this.filter[i] = filter[i];
      }

      // Only process the FIRST filter change (initial load)
      if (this.filterChangeCount === 1) {
        console.log("[ReportLabelMaker] First changeFilter - calling fetchData() ONCE");
        // Fetch chart data once on initial load
        this.fetchData();
        // Fetch history table data on initial load
        this.fetchHistoryData();
        this.isChangingFilter = false; // Reset flag
        return;
      }

      console.log("[ReportLabelMaker] Subsequent changeFilter - calling fetchData() and fetchHistoryData()");
      // For all subsequent filter changes, update both charts and table
      this.fetchData();
      this.fetchHistoryData();
      this.isChangingFilter = false; // Reset flag
    },
    fetchData() {
      console.log("[ReportLabelMaker] ===== fetchData() START =====");

      //Reset All Data to null
      for (var i in this.data) this.data[i] = null;

      //Remove filter from filter
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      delete filterlessFilter.filter;

      //Get Activation Report
      console.log("[ReportLabelMaker] Calling API: labelmaker-overview");
      this.$http
        .get(
          `/api/reports/labelmaker-overview?${qs.stringify(this.filter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          console.log("[ReportLabelMaker] API response: labelmaker-overview");
          this.data.checkingReportChart = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
        });

      //Get Report By PO Order
      console.log("[ReportLabelMaker] Calling API: labelmaker-po-report");
      this.$http
        .get(
          `/api/reports/labelmaker-po-report?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          console.log("[ReportLabelMaker] API response: labelmaker-po-report");
          this.data.reportByPo = resp.data.data;
          // console.log("Data report by PO:", this.data.reportByPo);
        })
        .catch((err) => {
          console.log(err);
        });

      console.log("[ReportLabelMaker] ===== fetchData() END =====");
    },
    async fetchHistoryData() {
      // Clear existing timer to debounce rapid calls
      if (this.historyFetchDataTimer) {
        clearTimeout(this.historyFetchDataTimer);
      }

      this.historyFetchDataTimer = setTimeout(() => {
        this.performFetchHistoryData();
      }, 300); // 300ms debounce
    },
    async performFetchHistoryData() {
      this.historyTableLoading = true;
      
      try {
        // Build filter object
        let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
        delete filterlessFilter.filter;

        let queryParams = {
          pagination: true,
          limit: this.historyLimitPerPage,
          page: this.historyCurrentPage,
          order: "DESC",
          by: "scan_date",
          ...filterlessFilter,
        };

        const url = `/api/reports/labelmaker-history?${qs.stringify(queryParams, {
          skipNulls: true,
          arrayFormat: "comma",
        })}`;

        const resp = await this.$http.get(url);
        
        console.log('[ReportLabelMaker] History API Response:', resp.data);
        
        let rawData = resp.data.data || [];
        
        // Process data according to the original process_data function
        for (var i in rawData) {
          rawData[i].label_maker = rawData[i].label_maker ? rawData[i].label_maker : '-';
          rawData[i].product_name = rawData[i].product_name ? rawData[i].product_name : '-';
          rawData[i].volume = rawData[i].volume ? (parseInt(rawData[i].volume))/1000 + ' Lt' : '-';
          rawData[i].qrcode = rawData[i].qrcode ? rawData[i].qrcode : '-';
          rawData[i].serial_number = rawData[i].serial_number ? rawData[i].serial_number : '-';
          rawData[i].status = rawData[i].status ? rawData[i].status : '-';
          rawData[i].scan_date = rawData[i].scan_date ? rawData[i].scan_date : '-';
        }
        
        // Check for pagination meta in various possible locations
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};
        
        console.log('[ReportLabelMaker] History Pagination Meta:', meta);
        
        // Process data
        this.historyTableData = rawData;

        // Handle pagination metadata - check multiple possible field names
        const currentPage = meta.currentPage || meta.current_page || meta.page || this.historyCurrentPage || 1;
        let total = meta.total || meta.totalItems || meta.total_count || meta.totalRecords || meta.count || 0;
        let lastPage = meta.lastPage || meta.last_page || meta.totalPages || meta.total_pages || meta.maxPage || 0;
        
        console.log('[ReportLabelMaker] Parsed history pagination:', { currentPage, total, lastPage, dataLength: this.historyTableData.length, limitPerPage: this.historyLimitPerPage });
        
        // If total is 0 but we have data, we need to estimate
        // If we got a full page of data, there might be more pages
        if (total === 0) {
          if (this.historyTableData.length === this.historyLimitPerPage) {
            // We got a full page, so there's likely more data
            // Set total to at least current page * limit, but we'll calculate lastPage differently
            total = this.historyCurrentPage * this.historyLimitPerPage;
            // We'll calculate lastPage based on whether we can go to next page
            lastPage = this.historyCurrentPage + 1; // At least one more page exists
          } else if (this.historyTableData.length > 0) {
            // We got partial data, so this is likely the last page
            total = (this.historyCurrentPage - 1) * this.historyLimitPerPage + this.historyTableData.length;
            lastPage = this.historyCurrentPage;
          } else {
            // No data
            total = 0;
            lastPage = 1;
          }
        } else if (total > 0) {
          // We have total, calculate lastPage if not provided
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.historyLimitPerPage);
          }
        }
        
        // Ensure lastPage is at least 1
        lastPage = Math.max(1, lastPage);
        
        // If we got a full page and we're on the last calculated page, there might be more
        if (this.historyTableData.length === this.historyLimitPerPage && this.historyCurrentPage >= lastPage) {
          lastPage = this.historyCurrentPage + 1;
        }

        console.log('[ReportLabelMaker] Final history pagination state:', { currentPage, total, lastPage });

        // Update pagination state
        this.$set(this, 'historyCurrentPage', Number.parseInt(currentPage));
        this.$set(this, 'historyMaxPage', Number.parseInt(lastPage));
        this.$set(this, 'historyTotal', Number.parseInt(total));
      } catch (err) {
        console.log('[ReportLabelMaker] Error fetching history data:', err);
        this.$set(this, 'historyTableData', []);
        this.$set(this, 'historyCurrentPage', 1);
        this.$set(this, 'historyMaxPage', 1);
        this.$set(this, 'historyTotal', 0);
      } finally {
        this.historyTableLoading = false;
      }
    },
    onHistoryLimitChange() {
      this.$set(this, 'historyCurrentPage', 1);
      this.fetchHistoryData();
    },
    changeHistoryPage(opt) {
      if (this.historyTableLoading) {
        return;
      }
      
      let newPage = this.historyCurrentPage;
      
      if (opt === 'prev') {
        newPage = Math.max(1, this.historyCurrentPage - 1);
      } else if (opt === 'next') {
        // Allow going to next page if we have more data or if we're not at maxPage
        if (this.hasMoreHistoryData || this.historyCurrentPage < this.historyMaxPage) {
          newPage = this.historyCurrentPage + 1;
        } else {
          return; // Can't go to next page
        }
      }
      
      if (newPage !== this.historyCurrentPage && newPage >= 1) {
        this.$set(this, 'historyCurrentPage', newPage);
        this.fetchHistoryData();
      }
    },
    formatDate(date) {
      if (!date || date === '-') return 'N/A';
      return moment(date).format("DD MMM YYYY HH:mm:ss");
    },
    getStatusStyle(status) {
      const styles = {
        Success: "color:green; font-weight: bold",
        Reject: "color:red; font-weight: bold",
        "Not Found": "color:grey; font-weight: bold",
        "Double Scan": "color:orange; font-weight: bold",
      };
      return styles[status] || "";
    },
    downloadReportHistoryExcel() {
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      delete filterlessFilter.filter;
      this.$http
        .get(
          `/api/reports/labelmaker-history?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((response) => {
          let wb = XLSX.utils.book_new();
          let exportFileName = 'Exported Data.xlsx';

          // console.log("Flattened data:", flattenedData);

          var ws = XLSX.utils.json_to_sheet(response.data.data, { raw: true });
          XLSX.utils.book_append_sheet(wb, ws, "Data");
          XLSX.writeFile(wb, exportFileName);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadReportbyPOExcel(data, title) {
      let wb = XLSX.utils.book_new();
      let exportFileName = title ? `${title}.xlsx` : "Exported Data.xlsx";

      // Flatten the data
      let flattenedData = [];

      data.forEach((item) => {
        item.content.forEach((contentItem) => {
          flattenedData.push({
            no_po: item.no_po,
            label_maker: item.label_maker,
            po_date: item.po_date,
            variant: contentItem.variant,
            qr_total: contentItem.qr_total,
            spare_total: contentItem.spare_total,
            scan_total: contentItem.scan_total,
            failed: contentItem.failed,
            activate: contentItem.activate,
          });
        });
      });

      // console.log("Flattened data:", flattenedData);

      var ws = XLSX.utils.json_to_sheet(flattenedData, { raw: true });
      XLSX.utils.book_append_sheet(wb, ws, "Data");
      XLSX.writeFile(wb, exportFileName);
    },
  },
};
</script>

<style scoped>
.btn-elegant-download {
  font-weight: 500 !important;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.table td,
.table th {
  text-align: center;
}

.box-content {
  padding: 20px;
  border-radius: 10px;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4B4B4B;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9D9D9D !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}

:deep(.popover-header) {
  background-color: #ffffff;
  border-bottom: none;
  font-weight: 600;
  font-size: 12px;
  color: #111111;
}

:deep(.popover-body) {
  background-color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  color: #9d9d9d;
}
:deep(.elegant-multiselect .multiselect__placeholder),
:deep(.elegant-multiselect .multiselect__single) {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #707070 !important;
}

:deep(.variant-select .multiselect__placeholder),
:deep(.variant-select .multiselect__single) {
  font-weight: 600 !important;
  color: #2D2D2D !important;
}
</style>
<style>
.elegant-multiselect .multiselect__placeholder {
  font-weight: 500 !important;
  font-size: 12px !important;
  color: #2D2D2D !important;
}
.elegant-flatpickr {
  font-weight: 600 !important;
  font-size: 12px !important;
}
</style>